import { IS_ACC_TOGGLE, SAME_AS_KTP } from '@src/config/id/constant';
import React from 'react';

class ToggleSwitch extends React.Component {
  constructor(props) {
    super(props);
    
    this.state = {
      checked: false
    };

    this.onToggleSwitchChange = this.onToggleSwitchChange.bind(this);
  }

  onToggleSwitchChange() {
    this.setState(
      (prevState) => ({ checked: !prevState.checked }),
      () => {
        // callback after state update
        if (this.props.onValueSelect) {
          this.props.onValueSelect(
            this.props.fieldItem,
            this.state.checked ? IS_ACC_TOGGLE.ACTIVE:IS_ACC_TOGGLE.INACTIVE
          );
        }
      }
    );
  }

  componentDidUpdate(prevProps) {
    // jab fieldItem change ho
    if (prevProps.fieldItem !== this.props.fieldItem) {
      let checked = false;

      const { fieldItem } = this.props;

      if (fieldItem?.value === true) {
        checked = true;
      } else if (
        fieldItem?.name === 'is_acc' &&
        fieldItem?.value === IS_ACC_TOGGLE.ACTIVE
      ) {
        checked = true;
      } else if (
        fieldItem?.name === 'per_sameas_cur' &&
        fieldItem?.value === SAME_AS_KTP
      ) {
        checked = true;
      }

      // infinite loop se bachne ke liye
      if (checked !== this.state.checked) {
        this.setState({ checked });
      }
    }
  }

  render() {
    const { checked } = this.state;

    return (
      <div className="ToggleSwitch ToggleSwitch__rounded">
        <div className="ToggleSwitch__wrapper">
          <div
            className={`Slider ${checked ? 'isChecked' : ''}`}
            onClick={this.onToggleSwitchChange}
          />
        </div>
      </div>
    );
  }
}

export default ToggleSwitch;
